import axios from 'axios';

import Helpers from '../common/helpers';
import apiConstants from './constants/api-constants';

class SharedApi {
  static getCountries(data) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.shared_routes.get_countries);

    return axios(request);
  }

  static getAccountManagerInfo() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.shared_routes.get_account_manager_info);

    return axios(request);
  }

  static getNews() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.shared_routes.get_news);

    return axios(request);
  }

  static getSites(active, pageCode) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.shared_routes.get_sites, null, {
      only_active: active,
      page_code: pageCode,
    });

    return axios(request);
  }
}

export default SharedApi;



// WEBPACK FOOTER //
// ./src/api/shared-api.js